import React from "react";
import { useState, useEffect } from "react";
import { configData } from "../config";
import { Helmet } from 'react-helmet';
import { Link,useNavigate,useLocation ,useParams } from 'react-router-dom';
import Loading from './Loading';
import './classes/CouponList.css';
import SalespersonSidebar from './SalespersonSidebar';


const CouponList = () => {

    const [isLoading, setIsLoading] = useState(true); 
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const { id } = useParams(); 
    const location = useLocation();
    const loggedin_uid = localStorage.getItem('drupal_uid');

    const [formData, setFormData] = useState({
        coupon_name: "",
        coupon_status: "",
    });
    const[successMessage,setSuccess] = useState('');
 const Message = location.state?.message; // Access the message
 
    const [couponUsageTimes, setCouponUsageTimes] =useState({});
     const [couponsList, setCouponsList] =useState([]);
    const[couponUsageDetails, setCouponUsageDetails] =useState({});

    const handleClick = async (id,coupon_code) => {
        const response = await fetch(
                 app_url+'smwwcommercecoupon/getcouponuserdetails?coupon_id='+id+'&coupon_code='+coupon_code,
                {
                    method: "GET",
  
                    headers: {
                    'Content-Type': 'application/json',
                    },
                }
            )           
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                setCouponUsageDetails(prev => ({
            ...prev,
                [id]:responsedata.data.result
            }));
            setCouponUsageTimes(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
            
       /*  setCouponUsageTimes(prev => ({
            ...prev,
            [id]: !prev[id]
        })); */
}
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };
useEffect(() => {
  if (Message) {
    setSuccess(Message);
    window.history.replaceState({}, '');
  }
}, [Message, location.state]);
    useEffect(() => {
        Promise.all([
            getcouponlist()
        ])
        .then(() => {
        
            setIsLoading(false);
        })
    },[]);
    async function getcouponlist() {
    
       
            const response = await fetch(
                 app_url+'smwwcommercecoupon/getlist',
                {
                    method: "GET",
  
                    headers: {
                    'Content-Type': 'application/json',
                    },
                }
            )           
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                setCouponsList(responsedata.data.result);
            }
       
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
          try {
            setIsLoading(true);
         const response = await fetch(app_url+'smwwcommercecoupon/getlist', {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: {
        'Content-Type': 'application/json',
      },
      });
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                setCouponsList(responsedata.data.result);
                setCouponUsageDetails({});
                setCouponUsageTimes({});
                setSuccess('');
            }
         }  catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
        }
    };
    const handleExport = async (event,id,coupon_code) => {
        event.preventDefault(); // stop page reload
    
        try {
            setIsLoading(true);
            const response = await fetch(
                 app_url+'smwwcommercecoupon/exportcouponuserdetails?coupon_id='+id+'&coupon_code='+coupon_code,
                {
                    method: "GET",
  
                    headers: {
                    'Content-Type': 'application/json',
                    },
                }
            )           
            const data = await response.json();
           
            const csvUrl = data.data.csvUrl;
            const urlParts = csvUrl.split('/');
            const fileName = urlParts[urlParts.length - 1];
            const link = document.createElement('a');
            link.href = csvUrl;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        
        }  catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
        }
    };
    
    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main">
                    {loggedin_uid && !Number.isNaN(loggedin_uid) ? (
                        <>
                            <Helmet><title>Coupon List</title></Helmet>
                            <div className="left"></div>
                            <div className="center left-center">
                                <h1>Coupon List</h1>
                                  {successMessage && (
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successMessage}
                        </div>
                        )}
                                <div className="coupon-list-container">
                                    <div>
                                        <form onSubmit={handleSubmit}>
                                            <label>Coupon Name</label>
                                            <input 
                                                type="text" 
                                                name="coupon_name" 
                                                id="coupon_name" 
                                                value={formData.coupon_name}
                                                onChange={handleChange}
                                            />

                                            <label>Coupon Status</label>
                                            <select 
                                                id="coupon_status" 
                                                name="coupon_status"
                                                value={formData.coupon_status}
                                                onChange={handleChange}
                                            >
                                                <option value="">-Select-</option>
                                                <option value="1">Active</option>
                                                <option value="2">Disabled</option>
                                                <option value="3">Archive</option>
                                            </select>

                                            <input 
                                                type="button" 
                                                name="apply" 
                                                value="Apply" 
                                                style={{
                                                    width:"155px", 
                                                    height: "30px", 
                                                    margin: "0px 5px"
                                                }} 
                                                className="form-submit" 
                                                onClick={handleSubmit}
                                            />
                                            <a
                                                href="/admin/smww-commerce/coupon-list"
                                                style={{
                                                    width:"155px", 
                                                    height: "30px", 
                                                    margin: "0px 5px",
                                                    textAlign:"center",
                                                    fontSize: "15px",
                                                    padding: "8px 0px",
                                                    color: "white",
                                                }} 
                                                className="form-submit">Clear</a> 
                                        </form>
                                        <a href="/admin/smww-commerce/coupon-create">+Add a Coupon</a>
                                    </div>
                                    <table className="couponlist-maintable">
                                        <thead>
                                            <tr>
                                                <th>Coupon Name</th>
                                                <th>Status</th>
                                                <th>No of times coupons used</th>
                                                <th>Operations</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {couponsList.map(couponDetails => (
                                            <>
                                                <tr key={couponDetails.id}>
                                                    <td>{couponDetails.coupon_name}</td>
                                                    <td>{couponDetails.status}</td>
                                                    <td>
                                                        <a 
                                                            href 
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                if (couponDetails.usage_count > 0) {
                                                                    handleClick(couponDetails.id,couponDetails.coupon_name);
                                                                }
                                                            }} 
                                                            style={{cursor: "pointer"}}
                                                        >
                                                            {couponDetails.usage_count}
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <Link to={`/admin/smww-commerce/coupon-edit/${couponDetails.id}`}>Edit</Link> &nbsp;&nbsp;
                                                        <Link to={`/admin/smww-commerce/coupon-delete/${couponDetails.id}`}>Delete</Link>
                                                    </td>
                                                </tr>
                                                {couponUsageTimes[couponDetails.id] && couponDetails.usage_count > 0 && (
                                                    <tr>
                                                        <td colspan="4">
                                                            <div className="couponlist-subtable">
                                                                <div className="panel panel-default">
                                                                    <div className="panel-body">
                                                                        <a href="">
                                                                            <input 
                                                                                type="button" 
                                                                                value="Export" 
                                                                                style={{height: "30px"}} 
                                                                                className="form-submit" 
                                                                                onClick={(event) => handleExport(event,couponDetails.id,couponDetails.coupon_name)}
                                                                            />
                                                                        </a>
                                                                        <table className="table table-bordered table-hover">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>Name</th>
                                                                                    <th>Order Number</th>
                                                                                    <th>Description</th>
                                                                                    <th>Paid By</th>
                                                                                    <th>Paid On</th>
                                                                                    <th>Amount Paid</th>
                                                                                    <th>Status</th>
                                                                                    <th>Salesperson</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {(couponUsageDetails[couponDetails.id] || []).map((couponSales, index) => (
                                                                                    <tr key={index}>
                                                                                        <td><a href={couponSales.user_link}>{couponSales.customerName}</a></td>
                                                                                        <td><a href={couponSales.order_link}>{couponSales.orderNumber}</a></td>
                                                                                        <td>{couponSales.description}</td>
                                                                                        <td>{couponSales.paidBy}</td>
                                                                                        <td>{couponSales.paidOn}</td>
                                                                                        <td>{couponSales.amountPaid}</td>
                                                                                        <td>{couponSales.paymentStatus}</td>
                                                                                        <td>{couponSales.salesPerson}</td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="right">
                                <SalespersonSidebar />
                            </div>
                        </>
                    ) : (
                        <><p>You are not authorized</p></>   
                    )}
                </div>
            )}
        </>
    );
};
export default CouponList;